import api from '@/api'

const $st = api.$student

export const { $student } = $st

